import { create } from "zustand";
import { useFetchUserReturnAcknowledgementSlice } from "../slices/UserReturnAcknowledgementSlices/fetchUserReturnPosSlice";
import { useAddUserManagerReturnPosSlice } from "../slices/UserReturnAcknowledgementSlices/addUserManagerReturnPosSlice";

interface UserReturnAcknowledgementInterface
  extends ReturnType<typeof useFetchUserReturnAcknowledgementSlice>,
    ReturnType<typeof useAddUserManagerReturnPosSlice> {}

export const UserReturnAcknowledgementStore =
  create<UserReturnAcknowledgementInterface>((...a) => ({
    ...useFetchUserReturnAcknowledgementSlice(...a),
    ...useAddUserManagerReturnPosSlice(...a),
  }));
